"use client"
import * as React from "react"
import { cn } from "@/lib/utils"

type TextWithBrProps = {
  text: string
  as?: keyof React.JSX.IntrinsicElements
  className?: string
}

export function TextWithBr({ text, as = "span", className }: TextWithBrProps) {
  const Tag = as as any
  const parts = React.useMemo(() => text.split(/<br\s*\/?>(?:\s*)/i), [text])
  return (
    <Tag className={cn(className)}>
      {parts.map((part, idx) => (
        <React.Fragment key={idx}>
          {part}
          {idx < parts.length - 1 ? <br /> : null}
        </React.Fragment>
      ))}
    </Tag>
  )
}

export default TextWithBr
